'use client';

import { Copy, CopyIcon } from 'lucide-react';
import { useCallback } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { toast } from 'sonner';
import { useCopyToClipboard } from 'usehooks-ts';
import { Button } from '../ui/button';
import { theme } from './theme';
export function Code({
  className,
  children
}: any) {
  const [_copied, copy] = useCopyToClipboard();
  const match = /language-(\w+)/.exec(className || '');
  const language = match?.[1];
  const onCopy = useCallback(async () => {
    await copy(children);
    toast.success('Code copied to clipboard');
  }, [children, copy]);
  return <div className="grid relative">
      <SyntaxHighlighter codeTagProps={{
      style: {
        fontFamily: 'var(--font-oxygen-mono)'
      }
    }} style={theme} language={language}>
        {children}
      </SyntaxHighlighter>
      <Button size="xs" variant="ghost" onClick={onCopy} className="absolute right-[-1rem] top-[-0.75rem] text-white/[0.5] m-2 px-2 hover:text-white hover:bg-background/[0.25]">
        <CopyIcon className="text-primary w-4 h-4 " /> Copy
      </Button>
    </div>;
}